<template>
  <div class="left_nav fcl fac box-sizing">
    <div class="top frw box-sizing fac fjb" :class="{top_nav_hide:nav_hide}" @click="hideNav">
      <div class="frw fac" v-if="!nav_hide">
        <img class="logo_pic" src="../assets/img/logo.jpg">
        <span class="logo_t">ISELF</span>
      </div>
      <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13 11C13 11.5523 12.5523 12 12 12H1C0.447715 12 0 11.5523 0 11C0 10.4477 0.447715 10 1 10H12C12.5523 10 13 10.4477 13 11ZM18 6C18 6.55228 17.5523 7 17 7H1C0.447716 7 0 6.55228 0 6C0 5.44772 0.447715 5 1 5H17C17.5523 5 18 5.44772 18 6ZM18 1C18 1.55228 17.5523 2 17 2H1C0.447716 2 0 1.55228 0 1C0 0.447715 0.447715 0 1 0H17C17.5523 0 18 0.447715 18 1Z"
          fill="#0B3275" fill-opacity="0.5"></path>
      </svg>
    </div>
    <div class="nav_cont frw box-sizing" :class="{nav_cont_nav_hide:nav_hide,fjc:nav_hide}">
      <span class="text_e frw fac fjc">E</span>
      <div class="fcl fas" v-if="!nav_hide">
        <span class="nowrap-space">{{user}}</span>
        <span class="live">LIVE</span>
      </div>
    </div>
    <div class="menu fcl f1">
      <div class="menu_items fcl" v-for="(menu,index) in allmenu" :key="index" :index="menu.menuname" v-if="menu.show">
        <div class="p_menu frw fac box-sizing" v-if="menu.menuname&&!nav_hide">{{menu.menuname}}</div>
        <div class="c_menu frw fac"
          :class="{c_menu_select:mouse_selected==index + '_' + i||$route.name==chmenu.menuname,fjc:nav_hide}"
          v-for="(chmenu,i) in menu.menus" :index="'/'+chmenu.url" :key="i" v-if="chmenu.show"
          @click="routeNavigate(chmenu.menuname,index,i)" @mouseenter="routrEnter(index,i)"
          @mouseleave="routrLeave(index,i)">
          <img class="menu-left-icon" :class="{icon_nav_hide:nav_hide}"
            :src="mouse_selected==index + '_' + i||$route.name==chmenu.menuname?chmenu.icon_s:chmenu.icon" alt="">
          <span class="menu-left-title" v-if="!nav_hide">{{chmenu.menuname}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    leftMenu,
    getCookie,
  } from '@/utils/util';
  import {
    auth
  } from '@/api/apiFun'
  export default {
    name: 'leftnav',
    data() {
      return {
        collapsed: false,
        allmenu: [],
        group_auth: '',
        home_icon: require('@/assets/icon/dashboard.png'),
        mouse_selected: '',
        user: getCookie('dkh_user'),
        nav_hide: false
      }
    },
    watch: {
      $route(to, from) {
        if (this.$store.state.auth && !this.$store.state.auth.includes(to.name)) {
          this.$router.push({
            name: from.name,
          });
        }
      }
    },
    // 创建完毕Status(里面是Action)
    created() {
      this.$root.Bus.$on('toggle', value => {
        this.collapsed = !value
      })
      auth().then(res => {
        this.$store.state.auth = res.datas.group_auth
        this.group_auth = res.datas.group_auth
        var lMenu = leftMenu;
        lMenu.forEach(item => {
          item.show = false;
          item.menus.forEach(item1 => {
            if (res.datas.group_auth.includes(item1.menuname)) {
              item1.show = true;
            } else {
              item1.show = false;
            }
          });
        });
        for (let i = 0; i < lMenu.length; i++) {
          const item1 = lMenu[i].menus;
          for (let j = 0; j < item1.length; j++) {
            const element = item1[j];
            if (element.show) {
              lMenu[i].show = true;
              break
            }
          }
        }
        this.allmenu = lMenu
      })
    },
    methods: {
      hideNav() {
        this.nav_hide = !this.nav_hide
        this.$emit('childsend', this.nav_hide)
      },
      routeNavigate(menuname, index, i) {
        this.$router.push({
          name: menuname
        })
      },
      routrEnter(index, i) {
        this.mouse_selected = index + '_' + i
      },
      routrLeave(index, i) {
        this.mouse_selected = ''
      }
    },
  }

</script>
<style scoped>
  .menu {
    width: 100%;
    margin-top: 10px;
  }

  .p_menu {
    color: rgba(11, 50, 117, .7);
    font-size: 12px;
    font-weight: 600;
    height: 50px;
    padding-left: 30px;
    padding-top: 10px;
  }

  .c_menu {
    height: 44px;
    width: 100%;
    cursor: pointer;
    border-left: 4px solid transparent;
    font-size: 14px;
    color: #4a4a4a;
    box-sizing: border-box;
  }

  .c_menu_select {
    background-color: rgba(0, 184, 194, .05) !important;
    border-left-color: #00b8c2;
    color: #00b8c2;
  }

  svg {
    fill: #0b3275 !important;
  }

  .c_menu_select span svg {
    fill: none !important;
    opacity: 1;
  }

  .c_menu_select span svg path {
    fill: #00b8c2 !important;
  }

  .menu-left-icon {
    width: 20px;
    height: 20px;
    margin-left: 28px;
  }

  .menu-left-title {
    margin-left: 20px;
  }

  .left_nav {
    width: 100%;
    height: 100vh;
    border-right: 1px solid rgba(17, 170, 178, .21176470588235294);
  }

  .logo_pic {
    height: 40px;
  }

  .logo_t {
    color: #063A4F;
    font-size: 18px;
    font-weight: 700;
    margin-left: 5px;
  }

  .top {
    width: 100%;
    padding: 14px 20px;
    cursor: pointer;
  }

  .nav_cont {
    background: rgba(180, 203, 213, .15);
    padding: 19px 30px;
    width: 100%;
    height: 80px;
  }

  .text_e {
    width: 38px;
    height: 38px;
    line-height: 38px;
    font-size: 18px;
    font-weight: bolder;
    background-color: rgb(0, 184, 194);
    color: #fff;
    border-radius: 100%;
    margin-right: 20px;
  }

  .nowrap-space {
    color: #2e384d;
    font-size: 14px;
    font-weight: 600;
  }

  .admin {
    font-size: 12px;
    color: #bfc5d2;
  }

  .live {
    border-radius: 50px;
    font-size: 10px;
    clear: both;
    font-family: Inter, Helvetica Neue, sans-serif;
    font-weight: 700;
    line-height: 12px;
    padding: 3px 12px;
    max-width: 70px;
    overflow: hidden;
    text-transform: uppercase;
    display: inline-block;
    color: #fff;
    background: #ecab03 linear-gradient(175.31deg, #f0aa22 -8.91%, #f05822 99.52%);
    margin-top: 10px;
  }

  .top_nav_hide {
    padding: 28px 0px;
    justify-content: center;
  }

  .nav_cont_nav_hide {
    padding: 19px 0;
  }

  .nav_cont_nav_hide .text_e {
    margin-right: 0;
  }

  .icon_nav_hide {
    margin-left: 0
  }

</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue